const LANGUAGES_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: undefined,
}

export default LANGUAGES_INITIAL_STATE
